(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recommendations"] && !Shopify.designMode) return;
  try {
    
  function initEsseRecommendations() {
    document.querySelectorAll('[data-esse-recommendations]:not([data-initialized])').forEach(section => {
      section.dataset.initialized = 'true';
      const excluded = new Set(section.dataset.excluded.split(',').filter(Boolean));
      const related = new Set(section.dataset.related.split(',').filter(handle => handle && handle !== 'all' && handle !== 'hot-selling' && handle !== 'frontpage'));
      const seen = new Set();
      const candidates = [...section.querySelectorAll('[data-recommendation-candidate]')].filter(item => {
        if (excluded.has(item.dataset.id) || seen.has(item.dataset.id)) return false;
        seen.add(item.dataset.id);
        return true;
      });
      let seed;
      try {
        seed = Number(sessionStorage.getItem('esse-recommendation-seed'));
        if (!seed) {
          seed = Math.floor(Math.random() * 2147483646) + 1;
          sessionStorage.setItem('esse-recommendation-seed', String(seed));
        }
      } catch {
        seed = Math.floor(Math.random() * 2147483646) + 1;
      }
      const random = () => {
        seed = seed * 16807 % 2147483647;
        return (seed - 1) / 2147483646;
      };
      for (let i = candidates.length - 1; i > 0; i--) {
        const j = Math.floor(random() * (i + 1));
        [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
      }
      const same = candidates.filter(item => item.dataset.collections.split(',').some(handle => related.has(handle)));
      const different = candidates.filter(item => !same.includes(item));
      const selected = same.slice(0, 2);
      selected.push(...different.slice(0, 4 - selected.length));
      if (selected.length < 4) selected.push(...same.slice(2, 2 + 4 - selected.length));
      const ordered = [];
      const relatedPicks = selected.filter(item => same.includes(item));
      const broaderPicks = selected.filter(item => !same.includes(item));
      while (relatedPicks.length || broaderPicks.length) {
        if (relatedPicks.length) ordered.push(relatedPicks.shift());
        if (broaderPicks.length) ordered.push(broaderPicks.shift());
      }
      const grid = section.querySelector('[data-recommendation-grid]');
      ordered.forEach(item => grid.append(item.content.cloneNode(true)));
      if (!selected.length) return;
      const more = section.querySelector('[data-recommendation-more]');
      if (selected.length > 2) {
        more.hidden = false;
        more.addEventListener('click', () => {
          const expanded = section.classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? more.dataset.less : more.dataset.more;
        });
      }
      section.dataset.ready = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initEsseRecommendations);
  else initEsseRecommendations();
  document.addEventListener('shopify:section:load', initEsseRecommendations);

  } catch(e) { console.error(e); }
})();
})();
